import * as Bowser from 'bowser';
import { useMemo } from 'react';

export const INSTANCE = Bowser.getParser((global ?? window).navigator.userAgent) as Readonly<Bowser.Parser.Parser>;

/**
 * Thin wrapper around Bowser.getParser
 *
 * Returns the parser for the current userAgent string if not provided.
 */
export function useBowser(userAgent?: string, skipParsing = false): Readonly<Bowser.Parser.Parser> {
  return useMemo(() => userAgent ? Bowser.getParser(userAgent, skipParsing) : INSTANCE, [userAgent, skipParsing]);
}
